import { put, select } from 'redux-saga/effects'
import importer from 'common/importer'
/* API */
const { okta } = importer('APIs/auth', null)
const { changeRecoveryQuestion } = okta
/* ACTIONS */
const Actions = importer('Stores/AuthCustom/Actions')
/* STATE */
const { user } = importer('Stores/AuthCustom/Select', null)
export default function * main ({ currentPassword, recoveryQuestion, recoveryAnswer }) {
  try {
    const { oktaUserId, oktaDigitalId } = yield select(user)
    yield put(Actions.changeRecoveryQuestionLoading())
    const res = yield changeRecoveryQuestion(oktaUserId, oktaDigitalId, currentPassword, recoveryQuestion, recoveryAnswer)
    yield put(Actions.changeRecoveryQuestionSuccess(res))
  } catch (error) {
    yield put(Actions.changeRecoveryQuestionFailure(error))
  }
}
